/* global localData */
if (document.querySelector('.contact-form-template')) {
  const contactForm = document.querySelector('.contact-form-template');
  const buttonForm = contactForm.querySelector('.send-contact-btn');
  let isLoading = true;
  const sendFormAjax = () => {
    const formData = {};
    document.querySelectorAll('.register-form input').forEach((input) => {
      const type = input.getAttribute('type');
      switch (type) {
        case 'text': {
          formData[input.name] = input.value.trim();
          const invalid = ((typeof input.getAttribute('required') === 'string') && input.value.length === 0);
          input.closest('.form-group').classList.toggle('is-validation-failed', invalid);
          break;
        }
        case 'email': {
          formData[input.name] = input.value.trim();
          const invalidE = (!/^[\w\d._-]+@[\w\d\-_.]+\.[\d\w][\d\w]+$/.test(formData[input.name]) && type === 'email');
          input.closest('.form-group').classList.toggle('is-validation-failed', invalidE);
          break;
        }
        case 'checkbox': {
          formData[input.name] = input.checked;
          const invalidC = ((typeof input.getAttribute('required') === 'string') && !input.checked);
          input.closest('.checkbox').classList.toggle('is-validation-failed', invalidC);
          break;
        }
        default:
      }
    });
    const validationFailed = document.querySelectorAll('.contact-form-template .is-validation-failed').length > 0;
    if (!validationFailed && isLoading) {
      isLoading = false;
      const ajax = new XMLHttpRequest();
      const formDataInput = new FormData();
      formDataInput.append('action', 'submitAbonmaForm');
      formDataInput.append('lang', localData.lang);
      formDataInput.append('id', localData.id);
      formDataInput.append('nonce', contactForm.dataset.nonce);
      formDataInput.append('inputs', JSON.stringify(formData));
      ajax.open('POST', localData.siteURL, true);
      ajax.onload = () => {
        const response = JSON.parse(ajax.responseText);
        window.location = response.data.url;
        isLoading = true;
      };
      ajax.send(formDataInput);
    }
  };
  buttonForm.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    sendFormAjax();
  });
}
